import {app} from "../serviceLMS"

export const getAllDomains = async () => {
  try {
    const response = await app.get("/user/api/client-api/admin/domains");
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch domains");
  }
};

export const getRegisteredDomains = async (page = 0, size = 10, search) => {
    try {
        const params = {
            page,
            size,
            sortBy: 'createdAt',
            sortDir: 'desc',
            ...(search && search.trim() && { search: search.trim() })
        };
        
        const response = await app.get('/user/api/client-api/admin/domains', { params });
        return response.data;
    } catch (error) {
        console.error("API Error:", error);
        const errorMessage = error?.response?.data?.message || "Failed to fetch domains";
        throw new Error(errorMessage);
    }
};

export const createAllowedDomain = async (domain) => {
    try {
        const payload = {
            domain: domain.trim().toLowerCase()
        };

        const response = await app.post('/user/api/client-api/admin/domains', payload);
        return response.data;
    } catch (error) {
        console.error("API Error creating domain:", error);
        const errorMessage = error?.response?.data?.message || "Failed to create domain";
        
        throw new Error(errorMessage);
    }
};

export const updateAllowedDomain = async (id, updateData) => {
    try {
        const payload = { ...updateData };
        if (payload.domain) {
            payload.domain = payload.domain.trim().toLowerCase();
        }

        const response = await app.put(`/user/api/client-api/admin/domains/${id}`, payload);
        return response.data;
    } catch (error) {
        console.error("API Error updating domain:", error);
        const errorMessage = error?.response?.data?.message || "Failed to update domain";
        
        throw new Error(errorMessage);
    }
};

export const deleteAllowedDomain = async (id) => {
    try {
        const response = await app.delete(`/user/api/client-api/admin/domains/${id}`);
        return response.data;
    } catch (error) {
        console.error("API Error deleting domain:", error);
        const errorMessage = error?.response?.data?.message || "Failed to delete domain";
        
        throw new Error(errorMessage);
    }
};


